import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const socialLinks = [
  { icon: 'ri-linkedin-line', href: 'https://tr.linkedin.com/in/orhan-haberdar-b8b99264' },
];

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900">
      {/* CTA Banner */}
      <div
        className="relative py-20 px-6 overflow-hidden"
        style={{
          backgroundImage: "url('https://okayisu.com/common/img/site/footer-img.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gray-900/80" />
        <div className="relative z-10 max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-8">
          <div>
            <h3 className="text-white text-3xl md:text-4xl font-bold mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {t('footer.ctaTitle')}<br />
              <span className="text-amber-400">{t('footer.ctaAccent')}</span>
            </h3>
            <p className="text-white/60 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
              {t('footer.ctaSubtitle')}
            </p>
          </div>
          <Link
            to="/iletisim"
            className="flex-shrink-0 bg-amber-500 hover:bg-amber-400 text-white font-bold px-8 py-4 rounded-full text-sm tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            {t('footer.ctaButton')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand column */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 bg-amber-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-flashlight-line text-white text-base" />
              </div>
              <span className="text-white font-bold text-lg tracking-widest" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                OKAYISU
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
              {t('footer.tagline')}
            </p>
            <div className="flex items-center gap-2.5">
              {socialLinks.map((s, idx) => (
                <a
                  key={idx}
                  href={s.href}
                  className="w-8 h-8 flex items-center justify-center border border-white/10 rounded-lg text-gray-500 hover:border-amber-500/50 hover:text-amber-400 transition-all duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Links columns */}
          <div>
            <h4 className="text-white font-bold text-sm mb-5 tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {t('footer.corporate')}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/hakkimizda" className="text-gray-400 hover:text-amber-400 text-sm transition-colors duration-200 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {t('footer.aboutUs')}
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-amber-400 text-sm transition-colors duration-200 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {t('footer.careers')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm mb-5 tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {t('footer.pages')}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-amber-400 text-sm transition-colors duration-200 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {t('footer.homePage')}
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-gray-400 hover:text-amber-400 text-sm transition-colors duration-200 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {t('footer.aboutUs')}
                </Link>
              </li>
              <li>
                <Link to="/projeler" className="text-gray-400 hover:text-amber-400 text-sm transition-colors duration-200 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {t('footer.projects')}
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-gray-400 hover:text-amber-400 text-sm transition-colors duration-200 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm mb-5 tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {t('footer.contactInfo')}
            </h4>
            <ul className="space-y-3">
              {[
                { icon: 'ri-map-pin-line', text: t('footer.address') },
                { icon: 'ri-phone-line', text: t('footer.phone') },
                { icon: 'ri-mail-line', text: t('footer.email') },
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-2.5">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-amber-500 text-xs`} />
                  </div>
                  <span className="text-gray-400 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs text-center" style={{ fontFamily: "'Inter', sans-serif" }}>
            {t('footer.rights')}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-gray-600 hover:text-gray-400 text-xs transition-colors duration-200" style={{ fontFamily: "'Inter', sans-serif" }}>
              {t('footer.privacyPolicy')}
            </a>
            <a href="#" className="text-gray-600 hover:text-gray-400 text-xs transition-colors duration-200" style={{ fontFamily: "'Inter', sans-serif" }}>
              {t('footer.termsOfUse')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}